<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản của button-->
      <li
        nz-submenu
        nzTitle="{{'hien_thi'| translate}}"
        [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <div *ngIf="device != 'mobile_portrait'"
            style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
            <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
              Ẩn hiển thị ở mobile
            </div>
            <nz-switch [(ngModel)]="objectChoosing.mobile_portrait_hidden"
              (ngModelChange)="updateHidden({'mobile_portrait_hidden': $event})"></nz-switch>
          </div>
          <div *ngIf="device != 'desktop'"
            style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
            <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
              Ẩn hiển thị ở desktop
            </div>
            <nz-switch [(ngModel)]="objectChoosing.desktop_hidden"
              (ngModelChange)="updateHidden({'desktop_hidden': $event})"></nz-switch>
          </div>
          <div *ngIf="device != 'tablet_landscape'"
            style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
            <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
              Ẩn hiển thị ở tablet landscape
            </div>
            <nz-switch [(ngModel)]="objectChoosing.tablet_landscape_hidden"
              (ngModelChange)="updateHidden({'tablet_landscape_hidden': $event})"></nz-switch>
          </div>
          <div *ngIf="device != 'tablet_portrait'"
            style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
            <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
              Ẩn hiển thị ở tablet portrait
            </div>
            <nz-switch [(ngModel)]="objectChoosing.tablet_portrait_hidden"
              (ngModelChange)="updateHidden({'tablet_portrait_hidden': $event})"></nz-switch>
          </div>
          <div *ngIf="device != 'mobile_landscape'"
            style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
            <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
              Ẩn hiển thị ở mobile landscape
            </div>
            <nz-switch [(ngModel)]="objectChoosing.mobile_landscape_hidden"
              (ngModelChange)="updateHidden({'mobile_landscape_hidden': $event})"></nz-switch>
          </div>
        </div>
      </li>
    </ul>
  </ng-container>
  <p style="color: red">
    *Để đăng nhập Zalo, vui lòng vào trang quản trị (admin)
  </p>
</div>